import Seo from "../components/Seo";

const policies = {
  "Privacy Policy": [
    ["Scope", "This preview explains the intended privacy structure for the Medein public website. Final production terms must be approved for the operating entity, regions, service providers, and connected systems."],
    ["Information submitted", "Public forms may request name, work email, organization, topic, and a non-confidential message. Do not submit patient information, personal health information, unpublished research data, security-sensitive details, or controlled technical material."],
    ["Purpose and routing", "Submitted information may be used to route product, science, partnership, investor, media, career, or support inquiries to the responsible team."],
    ["Retention and sharing", "Production retention periods, processors, cross-border transfers, security controls, and individual rights must be documented before form transmission is enabled."],
    ["Your choices", "A production privacy notice should explain access, correction, deletion, objection, and consent choices where applicable."],
  ],
  "Terms of Use": [
    ["Website purpose", "The site provides general company, scientific, platform, product-concept, pipeline, and partnership information."],
    ["No medical or professional advice", "Content is not medical advice, diagnosis, treatment guidance, investment advice, or a substitute for qualified professional review."],
    ["Research and product status", "Research concepts, pipeline programs, evidence levels, and availability may vary by region and may change after review. Public content does not imply regulatory approval or universal performance."],
    ["Acceptable use", "Users must not misuse the site, attempt unauthorized access, submit unlawful or sensitive information, or treat public summaries as operational instructions."],
    ["Intellectual property and links", "Brand, copy, visuals, and technical descriptions remain subject to the rights and permissions of their respective owners. External links, if added, require separate review."],
  ],
};

export default function LegalPage({ title }) {
  const sections = policies[title] || [];

  return (
    <section className="legal-page">
      <Seo title={title} description={`${title} for the Medein website.`} />
      <p className="section-label">Legal</p>
      <h1>{title}</h1>
      <p>Last reviewed: July 2026</p>
      <p className="legal-intro">
        This is a complete preview structure for legal review, not final legal advice. The operating entity,
        jurisdiction-specific terms, contact details, and connected service providers must be approved before launch.
      </p>
      {sections.map(([heading, text]) => (
        <section key={heading}>
          <h2>{heading}</h2>
          <p>{text}</p>
        </section>
      ))}
      <h2>Contact</h2>
      <p>Questions about this policy may be directed through the website contact form.</p>
    </section>
  );
}
